import { DEMO_TODAY } from '../fixtures';
import type { SurveyType } from '../vocabulary';
import type { DemoAction } from './actions';

/**
 * The initial review's own state (step 15, RNK-04): the survey it lists and the survey owner's
 * "in consideration" thresholds. It stood on the worklists' slice of act 4 until SR-230 made the
 * lists live and the worklists mock was deleted (the Lists design's Q3, ruled 2026-10-09); it is a
 * screen of its own, never a view (SR-221's R5), so it keeps only what it draws. Its decisions are
 * not here: each is `eligibility/set` on the record, act 2's, which the reinstatement and the DD
 * calls read too.
 */
export interface IThresholds {
  aum: number;
  production: number;
  op: 'AND' | 'OR';
  setBy: string;
  setAt: string;
}

export interface IInitialReviewState {
  survey: SurveyType;
  thresholds: IThresholds;
}

export function initialInitialReview(): IInitialReviewState {
  return {
    survey: 'FA',
    thresholds: { aum: 1500, production: 7, op: 'OR', setBy: 'Tomás Rivera', setAt: '2026-08-28' }
  };
}

export function initialReviewReducer(
  state: IInitialReviewState,
  action: DemoAction
): IInitialReviewState {
  switch (action.type) {
    case 'initial-review/survey':
      return action.survey === state.survey ? state : { ...state, survey: action.survey };
    case 'thresholds/set':
      return {
        ...state,
        thresholds: {
          aum: action.aum,
          production: action.production,
          op: action.op,
          setBy: action.by,
          setAt: DEMO_TODAY
        }
      };
    default:
      return state;
  }
}
